import { dataUserSearchSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSearchSolid = /*#__PURE__*/createIcon(dataUserSearchSolid)
export default IconUserSearchSolid
